export default {
  siteName: 'Saffe Dashboard',
  siteIcon: 'ion-flash',
  footerText: `Saffe © ${new Date().getFullYear()}. All rights reserved.`,
  enableAnimatedRoute: false,
  apiUrl: 'http://localhost:8080/v0/',
  siteUrl: 'http://localhost:8080/',
  cdnUrl: 'http://localhost:8080/cdn/',
  google: {
    analyticsKey: 'UA-xxxxxxxxx-1',
  },
  dashboard: '/dashboard',
};
